<template>
  <div v-if="currentArticle">
    <div class="mt-4 mb-4">
      <div class="row" v-if="customErrorMessage !== null">
        <div class="col-md-12">
          <b-alert
            :show="customErrorMessage !== null"
            dismissible
            variant="danger"
          >
            <span v-html="customErrorMessage"></span>
          </b-alert>
        </div>
      </div>
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <div class="mb-4">
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body mt-n2 mb-n2">
                  <div class="row mt-n2 d-flex justify-content-center">
                    <div class="col-md-8 col-lg-6">
                      <cool-select
                        v-model="selectedArticle"
                        :items="articles"
                        item-text="designation"
                        placeholder="Recherche article"
                        disable-filtering-by-search
                        @search="onSearchArticle"
                        @select="onSelectedArticle"
                        :search-text.sync="searchText"
                      >
                        <template #no-data>
                          {{
                            noData
                              ? 'Aucun resultat.'
                              : '2 caratères pour lancer la recherche.'
                          }}
                        </template>
                        <template #item="{ item }">
                          <div class="item">
                            <div>
                              <h5>{{ item.designation }}</h5>
                              <span v-if="item.reference" class="d-block">
                                Référence : {{ item.reference }}
                              </span>
                              <span v-if="item.unite" class="d-block">
                                Unité : {{ item.unite }}
                              </span>
                              <span v-if="item.article_type" class="d-block">
                                Type d'article :
                                {{
                                  item.article_type === 'produits'
                                    ? 'Produit'
                                    : 'Service'
                                }}
                              </span>
                            </div>
                          </div>
                        </template>
                      </cool-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <b-alert
            :show="itemListErrorMessage !== null"
            dismissible
            variant="danger"
          >
            <span v-html="itemListErrorMessage"></span>
          </b-alert>
          <div class="row mt-n4">
            <div class="col-md-12">
              <table class="card table table-sm">
                <thead>
                  <tr class="d-flex">
                    <th class="col-4">Référence</th>
                    <th class="col-4">Désignation</th>
                    <th class="col-3">Type</th>
                    <th class="col-1 text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in form.item_lists"
                    :key="index"
                    class="d-flex"
                  >
                    <td class="col-4" style="vertical-align: middle">
                      {{ item.reference }}
                    </td>
                    <td class="col-4" style="vertical-align: middle">
                      {{ item.designation }}
                    </td>
                    <td class="col-3" style="vertical-align: middle">
                      {{
                        item.article_type === 'produits' ? 'Produit' : 'Service'
                      }}
                    </td>
                    <td
                      class="col-1 text-center"
                      style="vertical-align: middle"
                    >
                      <a
                        class="cursor-pointer"
                        @click.prevent="removeItem(index)"
                      >
                        <i class="fa fa-trash font-size-17 text-danger"></i
                      ></a>
                    </td>
                  </tr>
                  <tr v-if="form.item_lists.length === 0" class="d-flex">
                    <td class="text-center col-12">Aucune donnée</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row mb-4 mt-n4">
            <div class="col-md-12 text-right">
              <button
                type="button"
                class="btn btn-secondary mr-4"
                @click.prevent="$router.push({ name: listUrl }).catch(() => {})"
              >
                Liste des remplaçants
              </button>

              <ButtonLoader
                :busy="form.busy"
                type="submit"
                customClass="btn btn-custom-primary w-40"
                loadText="Traitement en cours..."
                Text="Ajouter"
                style="min-width: 100px"
              ></ButtonLoader>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL_R from '@/http/article_stock/remplacant';
import URL_A from '@/http/article_stock/article';
import Form from 'vform';
import { CoolSelect } from 'vue-cool-select';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      form: new Form({
        item_lists: [],
      }),
      articles: [],
      selectedArticle: null,
      noData: false,
      timeoutId: null,
      searchText: null,
      itemListErrorMessage: null,
      customErrorMessage: null,
    };
  },
  components: {
    CoolSelect,
  },
  computed: {
    ...mapGetters('article', ['currentArticle']),
    listUrl() {
      return this.$route.name.split('-')[0];
    },
  },
  methods: {
    onSelectedArticle: function (select) {
      if (select) {
        var objExiste = window._.find(
          this.form.item_lists,
          (o) => o.article === select.uuid
        );
        if (!objExiste) {
          this.form.item_lists.push({
            article: select.uuid,
            designation: select.designation,
            reference: select.reference,
            unite: select.unite,
            article_type: select.article_type,
          });
        }

        this.searchText = null;
        this.selectedArticle = null;
        this.articles = [];
      }
    },
    async onSearchArticle(search) {
      const lettersLimit = 2;

      this.articles = [];
      this.noData = false;

      if (search.length < lettersLimit) {
        return;
      }

      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        await window.axios
          .get(URL_A.SEARCH_ARTICLE, {
            params: {
              search: search,
              onlyProduit: false,
              sortBy: 'designation',
              sortDesc: false,
            },
          })
          .then((resp) => {
            this.articles = window._.filter(
              resp.data,
              (a) => a.uuid !== this.currentArticle.uuid
            );
          })
          .catch();

        if (!this.articles.length) {
          this.noData = true;
        } else if (this.articles.length === 1) {
          this.onSelectedArticle(this.articles[0]);
        }
      }, 500);
    },
    removeItem: function (index) {
      this.form.item_lists.splice(index, 1);
    },
    submit() {
      this.itemListErrorMessage = null;
      this.customErrorMessage = null;
      this.form.article = this.currentArticle.uuid;
      this.form
        .post(URL_R.REMPLACANT)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);

          this.form.reset();
          this.form.clear();
        })
        .catch((err) => {
          window._.forEach(err.response.data.errors, (value, key) => {
            if (key.includes('item_lists')) {
              this.itemListErrorMessage = value[0];
            } else if (key.includes('custom')) {
              this.customErrorMessage = value[0];
            } else {
              this.form.errors.set('message', err.response.data.message);
            }
            return 0;
          });
        });
    },
  },
};
</script>

<style scoped></style>
